module.exports = __webpack_public_path__ + "static/img/01038B_1_R_20200912_fit.f8fad29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/01038B_1_R_20200912_fit.png
// module id = HJ4n
// module chunks = 0